import React, { useState  } from "react";
import Checkbox from "react-checkbox";

const CheckboxBasicComponent = (props) => {
    return (
        <Checkbox checked={true}  supportIntermediate={true}/> 
        
    )
}

export default CheckboxBasicComponent